export const translation = {
    columnMapping: {
        preview: 'Column mapping preview {{- name}}'
    },
    roi: {
        tableMetrics: 'ROI dashboard metrics',
        assetROI: 'Asset ROI metrics',
        cubeWarehouses: 'ROI reporting / table cube / warehouses',
        cubeUsers: 'ROI reporting / table cube / users',
        cubeTables: 'ROI reporting / table cube / tables'
    },
    usage: {
        warehouseUsage: 'Usage reporting / warehouse usage',
        warehouses: 'Usage reporting / warehouses',
        warehouseCube: 'Usage reporting / warehouse cube',
        cubeWarehouses: 'Usage reporting / warehouse cube / warehouses',
        cubeUsers: 'Usage reporting / warehouse cube / users'
    },
    ops: {
        join: {
            preview: 'Join preview',
            keys: 'Join keys',
            unmatched: 'Join unmatched rows'
        },
        extractJson: {
            metrics: 'Extract JSON metrics',
            preview: 'Extract JSON preview'
        },
        sql: {
            preview: 'SQL preview'
        },
        union: {
            preview: 'Union preview'
        },
        formula: {
            preview: 'Formula preview'
        },
        pivot: {
            preview: 'Pivot preview'
        },
        aggregate: {
            preview: 'Aggregate preview'
        },
        filter: {
            preview: 'Filter preview',
            rowCounts: 'Filter validation'
        },
        multiJoin: {
            preview: 'Multi Join Preview',
            keys: 'Multi Join (un)matched Rows',
            multiplication: 'Multi Join Multiplication Factor'
        }
    },
    explore: {
        preview: 'Exploration preview',
        dimensionFilters: 'Dimension filters',
        name: 'Exploration {{index}}',
        describe: 'Exploration: {{- name}}'
    },
    notebook: {
        preview: 'Notebook preview'
    },
    rowCount: 'Row count query',
    preview: 'Preview {{- name}}'
};
